export default {
  title: "Tariffs",
  tariff: "Tariff",
  yourTariff: "Your Tariff",
  lessTariffModal: {
    title: "Gift card issuance is not available on your tariff",
    subtitle: "To issue gift cards, switch to 'Promo' or 'Pro+' tariff",
  },
  lite_p: {
    title: "Lite",
    list: [
      '<span itemprop="name">Registration of 1 organization',
      '<span itemprop="name">Creation of 5 trading points',
      '<span itemprop="name">Simplified statistics',
      '<span itemprop="name">Access to RC KASSA',
      '<span itemprop="name">Electronic document management',
      '<span itemprop="name">Settlements 2 times per month',
      '<span itemprop="name">Q&A section',
    ],
  },

  faq: [
    {
      title: "How does client digitization work?",
      text: "<p>To digitize a client, you need to provide them with a promo code. It can be in the form of a referral link, QR code, or the digitization code itself. Using it, the client needs to register in the client service rcpay.ru.</p><br><p>Note: to scan the QR code, the client will need a camera with this function or a special QR code scanning app.</p>",
    },
    {
      title: "What does 'active' client mean?",
      text: "<p>This is a client you digitized who made a purchase in an online or offline establishment of the RC Group ecosystem. Online purchases include shopping in RC Market, purchasing certificates, activating Yandex services, buying user tariffs. Offline operations are purchases in city establishments using RC.Kassa.</p><br><p>When purchasing the 'Corporate' tariff, each partner participates in the '50% discount' promotion for tariff renewal. The main condition of this promotion is to digitize 500 or more 'active' clients.</p>",
    },
    {
      title: "What happens if I don't renew the tariff?",
      text: "<p>In this case, the account functionality will be reduced to the 'Basic' tariff level. You will retain access to the 'Client List' subsection but will lose the ability to issue Wallet cards, send Push notifications, and access the 'Cashless Tips' service.</p>",
    },
    {
      title: "How to attract and digitize more clients?",
      text: "<p>Use the 'Share' functionality to post referral links for digitization on social networks. Also place table tents, sticker labels, flyers, wobblers in your establishment.</p>",
    },
    {
      title: "My question isn't here, how can I get an answer?",
      text: "<p>Ask a question to technical support. To do this, click on the RC Group icon in the bottom right corner, select 'Telegram' and describe your problem in the message, attach screenshots if necessary. Our specialist will definitely contact you to resolve the issue as soon as possible.</p><br><p>You can also send an email to: <a href='mailto:hello@rc.company'>hello@rc.company</a></br><br>Or call: <b>8 (800) 500-57-62.</b></p>",
    },
  ],
  digitizedClientsCounter: "Digitized Clients Counter",
  activeClientsDigitized: "Active Clients Digitized",
  reg500AndMoreClients:
    "Register 500 or more <b>active clients</b> in the loyalty program to get a 50% discount on tariff renewal",
  choosePointToGenerateQr:
    "Select a trading point to generate a link and QR code for registering new clients in RC PAY.",
  afterBuyTariffYouCanGenerate:
    "After purchasing a tariff, the ability to generate a link and QR code for registering new clients in RC PAY will become available.",
  useLinkAndQrForRegNewClients:
    "Use the link and QR code to register new clients in RC PAY.",
  shareLink: "Share Link",
  anyOtherQuestions: "Any other questions?",
  tariffSuccessPayed: "Tariff '{tariff}' successfully paid",
  tariffPayFromMainEntity:
    "Tariff payment is made from the actual balance<br />of the main legal entity.",
  period: "Period",
  cost: "Cost",
  discount: "Discount {discount}%",
  totalToPay: "Total to Pay",
  lite: "Lite",
  promo: "Promo",
  plusPro: "Pro+",
  basic: "Basic",
  corporate: "Corporate",
  popular: "Popular",
  advanced: "Advanced",
  includesToTariff: "Included in Tariff",
  allInLitePlus: "Everything from Lite tariff, plus",
  allInPromoPlus: "Everything from Promo tariff",
  allInBasicPlus: "Everything from Basic tariff, plus",
  forFree: "Free",
  buyTariff: "Buy Tariff",
  tradingPoints: "trading points",
  products: "Products",
  unlimitProducts: "Unlimited products",
  uCanAddProductsToEMenu:
    "You can add {productsCount} products to the online catalog and receive online orders for them from RC PAY",
  canAddUnlimitProductsToEMenu:
    "You can add unlimited products to the online catalog and receive online orders for them from RC PAY",
  twoTgMailingPerWeek: "2 Telegram mailings per week",
  oneTgMailingPerDay: "1 Telegram mailing per day",
  canCreateAndSend2NotifyPerWeek:
    "You can create and send 2 notifications per week to clients of each trading point in Telegram bot",
  canCreateAndSend1NotifyPerDay:
    "You can create and send 1 notification per day to clients of each trading point in Telegram bot",
  basicAnalytics: "Basic analytics",
  analyticsHint: "Analytics by trading points and legal entities",
  accrualDeducationPoints: "Accrual and deduction of points in RC KASSA",
  enablingPaymentMethods: "Enabling payment methods",
  postingYourShopsInRC: "Placing your establishments in RC PAY",
  postingYourShopsHint:
    "Provided they comply with placement rules in RC PAY<br><br><a target='_blank' href='/docs/Placement_Rules.pdf'>See establishment placement rules in RC PAY</a>",
  gettingOnlineOrders: "Receiving online orders for your products/services",
  orderPromotionYourShops: "Order promotion of your trading points",
  advancedAnalytics: "Advanced analytics",
  advancedAnalyticsHint:
    "Analytics by trading points, legal entities, cashiers, clients and RFM analysis",
  evaluationCashierWork: "Cashier work evaluation",
  digitizingClients: "Client digitization",
  accessToClientsList: "Access to client list",
  infoAboutAllClients:
    "Information about all clients who visited your establishment, their contacts, receipts and statistics",
  pushNotifyToClientWalletCard: "Push notifications to clients on Wallet card",
  scoringPointsByGroups: "Points accrual by client groups",
  uCanSetDifferentPercentAward:
    "You can set different reward % depending on clients' purchase amounts",
  distributionRCCard: "RC card distribution",
  designWalletCard: "Wallet card design",
  issuingGiftCard: "Gift card issuance",
  priorityMaintenance: "Priority maintenance",
  monetizationUpTo30Percent:
    "Monetization up to 30% of client's accrued reward",
  monetizationHint:
    "If you have the opportunity to receive income from the loyalty program within the framework of the activities for which your organization was created",
  adding1Entity: "Adding 1 legal entity",
  accessToOperationsHistory: "Access to operations history",
  basicCabinetFunctional: "Basic account functionality",
  discountOnTariffRenewal: "50% discount on tariff renewal",
  discountOnTariffRenewalHint:
    "50% discount is provided if you've digitized 500 or more active clients since the last tariff purchase<br><br><a href='#clients-counter'>See client counter</a>",
  autoConnectIfFreeTariff:
    "Automatically connected if no paid tariff is purchased.",
  tariffBuyingWillAvailableFromDate:
    "Tariff purchase will be available from {date}",
  entityOnModeration: "Legal entity is under moderation",
  tariffBuyingWillAvailableAfterModeration:
    "Tariff purchase will be available after the legal entity passes moderation.",
  notEnoughMoney: "Insufficient funds",
  tariffPayingFromFactBalance:
    "Tariff payment is made from the actual balance of the main legal entity.",
  forBuyingTariffNeedReplenish:
    "To purchase tariff '{tariff}' you need to replenish {entity} balance by at least {sum} ₽",
  replenishBalance: "Replenish Balance",
  canCreate: "Can create",
  forTransitionToTariffConnectWithUs:
    "To switch to a paid tariff, please contact technical support <a href='mailto:hello@rc.city;>hello@rc.city</a>",
};
